// extracted by mini-css-extract-plugin
module.exports = {"row":"AlpInfoRow_row__2l254","label":"AlpInfoRow_label__1_NVj","icon":"AlpInfoRow_icon__lfVAH","value":"AlpInfoRow_value__2txmd"};